// localStorage 浏览器永久缓存
export const Local = {
  // 设置
  set(key, val) {
    window.localStorage.setItem(key, JSON.stringify(val));
  },
  // 获取
  get(key) {
    let json = window.localStorage.getItem(key);
    return JSON.parse(json);
  },
  // 移除指定
  remove(key) {
    window.localStorage.removeItem(key);
  },
  // 移除全部
  clear() {
    window.localStorage.clear();
  },
};

// sessionStorage 浏览器临时缓存
export const Session = {
  // // 设置
  // set(key, val) {
  // 	window.sessionStorage.setItem(key, JSON.stringify(val));
  // },
  // // 获取
  // get(key) {
  // 	let json = window.sessionStorage.getItem(key);
  // 	return JSON.parse(json);
  // },
  // // 移除指定
  // remove(key) {
  // 	window.sessionStorage.removeItem(key);
  // },
  // // 移除全部
  // clear() {
  // 	window.sessionStorage.clear();
  // },

  // 全部改成localStorage
  // 设置
  set(key, val) {
    window.localStorage.setItem(key, JSON.stringify(val));
  },
  // 获取
  get(key) {
    let json = window.localStorage.getItem(key);
    return JSON.parse(json);
  },
  // 移除指定
  remove(key) {
    window.localStorage.removeItem(key);
  },
  // 移除全部
  clear() {
    window.localStorage.clear();
  },
};
